import axios from "axios";
import config from "../../config";
const apiurl = config.ADMIN_BASE_URL;

const getToken = () => {
    return localStorage.getItem("cookies");
};


export const getAllClaimedFestivals = async (search, page) => {
    try {
        const response = await axios.get(`${apiurl}/film-festivals/claims?search=${search}&page=${page}`, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching claimed festivals:", error);
        throw error;
    }
};


export const getUsersClaimedFestival = async (festivalId, search, page) => {
    try {
        const response = await axios.get(`${apiurl}/film-festivals/${festivalId}/claims?search=${search}&page=${page}`, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching users claimed festival:", error);
        throw error;
    }
};


export const updateClaimStatus = async (film_festival_id, claimID, status) => {
    try {
        const response = await axios.put(`${apiurl}/film-festivals/${film_festival_id}/claims/${claimID}`, {
            claim_request_status: status,
        }, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error updating claim status:", error);
        throw error;
    }
};


export const getFestivalPayments = async (search = "", page = 1, status = "") => {
    try {
        console.log("Fetching festival payments with search:", search, "page:", page, "status:", status);
        const params = new URLSearchParams();
        if (search) params.append("search", search);
        if (status) params.append("status", status);
        params.append("page", page);

        const response = await axios.get(`${apiurl}/film-festivals/submissions?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching festival payments:", error);
        throw error;
    }
};


export const getFestivalSubmissions = async (festivalId, search = "", page = 1) => {
    try {
        const params = new URLSearchParams();
        if (search) params.append("search", search);
        params.append("page", page);

        const response = await axios.get(`${apiurl}/film-festivals/${festivalId}/submissions?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching festival submissions:", error);
        throw error;
    }
};

export const getFestivalGlobaleFees = async () => {
    try {
        const response = await axios.get(`${apiurl}/platform-settings/platform-fee`, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching festival global fees:", error);
        throw error;
    }
};

export const updateFestivalGlobalFees = async (feesData) => {
    try {
        console.log("Updating festival global fees with data:", feesData);
        const response = await axios.put(`${apiurl}/platform-settings/platform-fee`, feesData, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error updating festival global fees:", error);
        throw error;
    }
};

export const getAllFestival = async (search = "") => {
    try {
        const params = new URLSearchParams();
        if (search) params.append("search", search);
        const response = await axios.get(`${apiurl}/platform-settings/platform-fee/film-festivals/list?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching all festivals:", error);
        throw error;
    }
};

export const getListOfSpecificFestivals = async () => {
    try {
        const response = await axios.get(`${apiurl}/platform-settings/platform-fee/film-festivals`, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching specific festivals:", error);
        throw error;
    }
};

export const manageSpecificFestivals = async (payload) => {
    try {
        const response = await axios.post(`${apiurl}/platform-settings/platform-fee/film-festivals`, payload, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error managing specific festivals:", error);
        throw error;
    }
};

export const getPlatformGstDetails = async () => {
    try {
        const response = await axios.get(`${apiurl}/platform-settings/gst`, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching platform GST details:", error);
        throw error;
    }
};


// ─── Commission Fee Settings ────────────────────────────────────────────────

export const getGlobalCommission = async () => {
    try {
        const response = await axios.get(`${apiurl}/platform-settings/commission`, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching global commission:", error);
        throw error;
    }
};

export const updateGlobalCommission = async (commissionData) => {
    try {
        const response = await axios.put(`${apiurl}/platform-settings/commission`, commissionData, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error updating global commission:", error);
        throw error;
    }
};

export const getFestivalCommission = async (festivalId) => {
    try {
        const response = await axios.get(`${apiurl}/platform-settings/commission/festivals/${festivalId}`, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching festival commission:", error);
        throw error;
    }
};

export const updateFestivalCommission = async (festivalId, commissionData) => {
    try {
        const response = await axios.put(`${apiurl}/platform-settings/commission/festivals/${festivalId}`, commissionData, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error updating festival commission:", error);
        throw error;
    }
};

export const deleteFestivalCommission = async (festivalId) => {
    try {
        const response = await axios.delete(`${apiurl}/platform-settings/commission/festivals/${festivalId}`, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error deleting festival commission:", error);
        throw error;
    }
};

// ─── Festival Bank Account ──────────────────────────────────────────────────

export const getFestivalBankAccount = async (festivalId) => {
    try {
        const response = await axios.get(`${apiurl}/festivals/${festivalId}/bank-account`, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching festival bank account:", error);
        throw error;
    }
};

export const saveFestivalBankAccount = async (festivalId, bankData) => {
    try {
        const response = await axios.post(`${apiurl}/festivals/${festivalId}/bank-account`, bankData, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error saving festival bank account:", error);
        throw error;
    }
};

export const verifyFestivalBankAccount = async (festivalId) => {
    try {
        const response = await axios.post(`${apiurl}/festivals/${festivalId}/bank-account/verify`, {}, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error verifying festival bank account:", error);
        throw error;
    }
};

export const linkFestivalRouteAccount = async (festivalId) => {
    try {
        const response = await axios.post(`${apiurl}/festivals/${festivalId}/bank-account/link-route`, {}, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error linking festival route account:", error);
        throw error;
    }
};

export const deactivateFestivalRouteAccount = async (festivalId) => {
    try {
        const response = await axios.post(`${apiurl}/festivals/${festivalId}/bank-account/deactivate-route`, {}, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error deactivating festival route account:", error);
        throw error;
    }
};

// ─── Festival Payments Ledger ───────────────────────────────────────────────

export const getFestivalPaymentsOverview = async (search = "", page = 1, status = "", sortBy = "last_payment_desc") => {
    try {
        const params = new URLSearchParams();
        if (search) params.append("search", search);
        if (page) params.append("page", page);
        if (status) params.append("status", status);
        if (sortBy) params.append("sort_by", sortBy);
        const response = await axios.get(`${apiurl}/festival-payments?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching festival payments overview:", error);
        throw error;
    }
};

export const getFestivalPaymentDetail = async (festivalId, search = "", page = 1, status = "") => {
    try {
        const params = new URLSearchParams();
        if (search) params.append("search", search);
        if (page) params.append("page", page);
        if (status) params.append("status", status);
        const response = await axios.get(`${apiurl}/festival-payments/${festivalId}?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching festival payment detail:", error);
        throw error;
    }
};

export const calculateFeePreview = async (mode, amount, festivalId, currency = "INR") => {
    try {
        const params = new URLSearchParams({
            mode,
            amount: String(amount),
            festival_id: String(festivalId),
            currency,
        });
        const response = await axios.get(`${apiurl}/festival-payments/calculate-preview?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error calculating fee preview:", error);
        throw error;
    }
};

export const getFestivalPlatformFee = async (festivalId) => {
    try {
        const response = await axios.get(`${apiurl}/platform-settings/platform-fee/film-festivals/${festivalId}`, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching single festival platform fee:", error);
        throw error;
    }
};

// Aliases and helper functions for Finance & Tax settings
export const getPlatformFeeSettings = getFestivalGlobaleFees;
export const getGloblePlatformFee = getFestivalGlobaleFees;
export const savePlatformFeeSettings = updateFestivalGlobalFees;
export const getCommissionSettings = getGlobalCommission;
export const saveCommissionSettings = updateGlobalCommission;
export const sendFinanceSettingsOtp = async (section) => {
    const response = await axios.post(`${apiurl}/platform-settings/send-otp`, { section }, {
        headers: {
            Authorization: `Bearer ${getToken()}`,
        },
    });
    return response.data;
};

export const issueFestivalPaymentRefund = async (paymentId, payload = {}) => {
    try {
        const response = await axios.post(`${apiurl}/festival-payments/${paymentId}/refund`, payload, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error issuing festival payment refund:", error);
        throw error;
    }
};
